/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Validation_Schedulerequired3Inputs */

const en_coinvestments_draftemail_validation_schedulerequired3 = /** @type {(inputs: Coinvestments_Draftemail_Validation_Schedulerequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a send date and time`)
};

/**
* | output |
* | --- |
* | "Pick a send date and time" |
*
* @param {Coinvestments_Draftemail_Validation_Schedulerequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_validation_schedulerequired3 = /** @type {((inputs?: Coinvestments_Draftemail_Validation_Schedulerequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Validation_Schedulerequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_validation_schedulerequired3(inputs)
});
export { coinvestments_draftemail_validation_schedulerequired3 as "coInvestments_draftEmail_validation_scheduleRequired" }